export const slbCheckout = {
    quote: {
        label: "Quote estimation",
        profiles: "Selection of profiles",
        simulation: "Simulation estimations",
        storage: "Storage and contingency credit",
        note: "If you plan to simulate over 300 hours, require multiple realizations, or have specific simulation needs, please <span id='contactUs'>contact a Delfi Specialist</span> for additional support. Annual commitment options are also available.",
        forms: {
            size: {
                SMALL: "Small",
                MEDIUM: "Medium",
                LARGE: "Large",
                OTHER: "Other",
                NO_SIMULATION: "No simulation"
            },
            cores: "{{cores}} cores",
            hoursPerMonth: "Simulation hours per month",
            minHours: "0",
            additionalTerabytes: "ADDITIONAL TERABYTES (TB):",
            currencyPerMonth: "USD/MONTH:",
            performance: {
                SMALL: {
                    RESERVOIR: "Perform single well history match and forecast reservoir simulation.",
                    RESERVOIROPTIONAL: "Perform single well history match and forecast reservoir simulation.",
                    FLOW_ASSURANCE: "Ideal for single users performing FEED & design studies."
                },
                MEDIUM: {
                    RESERVOIR: "Perform multiple wells history match and forecast reservoir simulations.",
                    RESERVOIROPTIONAL: "Perform multiple wells history match and forecast reservoir simulations.",
                    FLOW_ASSURANCE: "Ideal for single users performing FEED & design studies."
                },
                LARGE: {
                    RESERVOIR: "Perform multiple well history match and forecast reservoir simulations.<br/> Potential to run limited sensitivity and uncertainty optimization workflows.",
                    RESERVOIROPTIONAL: "Perform multiple well history match and forecast reservoir simulations.<br/> Potential to run limited sensitivity and uncertainty optimization workflows.",
                    FLOW_ASSURANCE: "Perform more complex feasibility studies and field development designs, with multiple users accessing the simulator."
                },
                OTHER: "Customize according to your project’s needs:"
            }
        },
        alerts: {
            allowanceUpdated: "Contingency Credit has been updated to reflect your current selection<br/> The suggested value is: {{suggestedValue}} USD/MONTH"
        }
    },
    storage: {
        menu: {
            tooltip: "Your profile selections don't require simulation"
        },
        errors: {
            info: 'We are sorry, but your transaction could not be completed at this time. Please contact a <span id="contactUs">SLB representative</span> so that they can assist you in completing your order.'
        }
    },
    summary: {
        label: "Summary",
        title: '{{cartType}} Budget Summary',
        edit: "Edit",
        subtotal: "Subtotal*",
        committed: "Committed",
        onDemmand: "On demand",
        total: {
            activationPayment: "ACTIVATION PAYMENT**",
            monthlyStimate: "Rolling monthly estimate",
            payment: "Total Payment",
            next: "Total",
            paid: "Total Paid",
            balance: "Balance",
            deposit: "Deposit Paid",
            refunded: "Deposit Refunded",
            monthlySubscription: "MINIMUM MONTHLY SUBSCRIPTION COMMITMENT OF {{commitment}} (more information in <a href='https://www.software.slb.com/slb-online-services-commercial-schedule' target='_blank'>Terms and Conditions</a>)"
        },
        storage: {
            title: 'Storage',
            teraBytes: "TB",
            tooltip: "Each Delfi Petrotechnical Suite deployment requires a minimum of 2 TB of storage. To buy additional storage, please indicate the number of terabytes you require. The cost per terabyte is {{costPerTerabyte}}."
        },
        contingency: {
            title: 'Contingency credit',
            tooltip: "This option will increase the monthly cap to allow for additional solutions and services."
        },
        estimation: {
            title: 'Simulation estimations',
            tooltip: "",
            hours: "simulation hours",
            cores: "cores",
            multipleRealizations: "multiple realizations"
        },
        terms: {
            simulation: "**Because your order includes a Delfi Profile that requires Simulation, a deposit equivalent to {{deposit}} months of your monthly estimate is required in order to activate your subscription. At the end of each billing cycle, your credit card will be charged based on the actual usage for the period."
        },
        solution: {
            title: {
                delfi: "Selected Cloud Solutions"
            }
        },
        companyName: 'Company name'
    },
    delfiReadiness: {
        label: "Delfi - Readiness Assessment"
    },
    shipping: {
        label: "Shipping & Billing",
        contactUs: "Need more information? Contact a",
        specialist: "Delfi specialist.",
        fieldsRequired: "These fields are required",
        generalInfoForm: {
            titleLabel: "Title",
            firstNameLabel: "First Name",
            lastNameLabel: "Last Name",
            jobTitleLabel: "Job title",
            phoneNumberLabel: "Phone Number <img src='/_ui/responsive/common/images/icon_info_gray.png' alt='icon_info'><span class='slb-tooltip'>WE WILL ONLY CALL YOU IN CASE OF ORDER ISSUES</span>",
            phoneNumberPlaceholder: "(123) 456 7890"
        },
        addressConfirmation: {
            title: 'Address validation',
            addressEntered: 'SHIPPING ADDRESS ENTERED',
            addressFound: 'SHIPPING ADDRESS FOUND',
            useSelectedAddress: 'Use Selected Address'
        },
        addressForm: {
            line1Label: "Address 1",
            line1PoLabel: "P.O. BOX",
            line2Label: "Address 2",
            countryLabel: "Country",
            cityLabel: "City",
            stateLabel: "State",
            zipCodeLabel: "Zip Code",
            line1Placeholder: "Address 1",
            line1PoPlaceholder: "PO Box",
            line2Placeholder: "Address 2",
            countryPlaceholder: "Country",
            cityPlaceholder: "City",
            statePlaceholder: "State",
            zipCodePlaceholder: "ZIP Code/Postal code"
        }
    },
    payment: {
        label: "Payment information",
        select: "Select a payment method",
        safe: "Your information is safe with us.",
        add: "Add New / Edit",
        addSafe: "Please Add & Save a payment method before you'll be able to use it",
        return: "Return To Payment Method Selection",
        transactionTime: "This session will expire in {{time}} minutes",
        ending: "Ending ",
        bankAccount: "Bank Account  ",
        errors: {
            concourseSupport: "We are sorry but your transaction could not be completed at this time; please try again later or contact customer service at 555-555-5555",
            concourseError: "The system is unable to recognize the bank account details that you have entered.  Please <span id='contactUs'>Contact Us</span> to assist you in completing your transaction"
        }
    },
    review: {
        label: "Review and place order",
        shipping: "Shipping address",
        billing: "Billing address",
        payment: {
            title: "Payment details",
            ending: "Ending in ",
            expiring: "Expires in ",
            USBank: 'United States bank',
            CABank: 'Canadian bank',
            category: '{{category}} Account '
        },
        subtotal: {
            title: "Subtotal",
            committed: "Committed subtotal*",
            paymentToday:  "Payment today",
            estimatedTax: "Estimated Tax",
            taxInfo: "The tax indicated on the checkout form and charged to your method of payment is an estimate. The final tax amount will be calculated at the end of each subscription period based on actual consumption."
        },
        coupon: {
            hasCoupon: "Do you have a Personal Activation Code that would you like to apply to your order?",
            placeholder: "ENTER COUPON CODE",
            terms: "By using your Personal Activation Code you agree with the Progam <a href='/referrals-terms-conditions'>Terms and condition.</a>",
            minimum: "Minimum 2 months active subscription required. Discount will be applied to the second month.",
            currentCoupon: "Personal Activation Code: "
        },
        termsAndConditions: {
            title: "Terms and Conditions",
            decline: "Decline",
            accept: "Accept",
            tryAgain: {
                title: "Info",
                description: "To continue we require acceptance of the SLB Online Services T&Cs for access to Delfi",
                accept: "Try Again"
            }
        },
        agora: {
            gateways: "Agora gateways",
            apps: "Agora Edge apps",
            estimatedPaymentToday: "Estimated Total Payment Today",
            estimatedSubsequentPayment: "Estimates Subsequent Payment Each Year",
            subsequentPayment: "Subsequent payment each year",
            estimatedSubsequentPaymentMonthly: "Estimates Subsequent Payment Each Month",
            subsequentPaymentMonthly: "Subsequent payment each month"
        },
        errors: {
            placeOrder: "We are sorry, but your transaction could not be completed at this time. Please contact a <span id='contactUs'>SLB representative</span> so that they can assist you in completing your order."
        }
    },
    readiness: {
        menu: {
            tooltip: "Readiness Assessment temporarily out of service"
        }
    },
    confirmation: {
        help: "Having issues with your order?",
        copy: "A copy of your receipt has been sent to",
        orderNumber: "Order number: ",
        order: "Order ",
        orderDate: "Order date ",
        backToProducts: "Back to {{cartType}} products",
        backToSlb: "Browse Other SLB Offerings",
        backToNext: "Return to NExt",
    },
    orbital: {
        payment: {
            label: "Payment & Place order"
        },
        review: {
            label: "Review order"
        }
    },
    license: {
        hardware: {
            label: "Licensing Hardware"
        },
        single: "Single Server",
        redundant: "Redundant servers (Quorum)",
        dongle: "ID of a USB dongle this order will be licensed at: *",
        dongles: "IDs of a USB dongles this order will be licensed at: *",
        macAddress: "MAC Address of server will be licensed at: *",
        macAddresses: "MAC Addresses tied to the server in order to be licensed: *",
        currentDongleId: 'Current dongle ID *',
        currentDongleIds: "Current dongle IDs *",
        currentMacId: 'Current MAC ID *',
        currentMacIds: "Current MAC IDs *",
        format: "X-XXXXXXX",
        formatMac: "XX-XX-XX-XX-XX-XX",
        learn: "Not sure? Learn more about licensing hardware.",
        dongleId: "Dongle ID",
        hostId: "Host ID",
        macAddressId: "MAC Address",
        dongle1: "DONGLE 1",
        dongle2: "DONGLE 2",
        dongle3: "DONGLE 3",
        macAddress1: "MAC ADDRESS 1",
        macAddress2: "MAC ADDRESS 2",
        macAddress3: "MAC ADDRESS 3",
        title: "DONGLE ID",
        learnModal: "<p>The Dongle is the CodeMeter that your Petrel is licensed to. The Dongle ID is printed on the dongle body or the tag attached to the dongle, using a format such as 1-2345678. <br>To obtain the Petrel Dongle ID, you can also plug the dongle in your computer, launch the SLB licensing tool and use the Request dialog box to verify your dongle and mac address IDs.Alternatively, you can open the Code Meter Control Center on the license tab. The Dongle ID will be labeled as “Serial”.</p> <h3>MAC ADDRESS</h3> <p>Mac address or Ethernet address of a device is a unique identifier assigned to a Network Interface Controller (NIC).<br>To get your mac address launch the “command prompt” app.<br>For Windows 7 and 8, click on Start at the bottom left of the desktop, type, “cmd.exe”.<br>For Windows 10, open the Windows menu or Search menu, and search for “command prompt” and press Enter.<br>On the command line enter <b>ipconfig/all</b>. For systems with multiple addresses, you may need to use <b>getmac /v</b> to identify the Ethernet address.<br>Use the Ethernet address for your licenses. For a Windows machine it is the physical address listed under ‘Ethernet Adapter Ethernet’, ‘Ethernet Adapter Ethernet 2’, or ‘Ethernet Adapter Local Area Connection’ depending on your computer.<br>Do not use any Virtual address (normally with many zeros, e.g.- “02-50-41-00-00-01”, “... Virtual Ethernet adapter”) or docking station addresses. For laptops users, please run the <b>ipconfig/all</b> <b><u>with and without the docking station</u></b> and identify the physical address that is present in both. Licenses locked to docking stations will only work when the computer is docked.</p>"
    },
    order: {
        details: {
            label: "Order Details",
            companyName: "Company Name",
            companyAddress: "Company Address",
            clientCompanyName: "Client's Company Name",
            clientCompanyAddress: "Client's billing address",
            poNumber: "PO Number (optional)",
            isvComment: "Comment (optional)",
            clientDetails: "Client's details",
            comments: "Comments",
            paymentLabel: "Payments",
            billingPeriod: 'Billing Period',
            amount: 'Amount',
            paymentDate: 'Payment date',
            paymentAmount: 'Payment amount',
            deposit: 'Deposit',
            updatePayment: 'Update Payment Method'
        },
        history: {
            placed: "Placed",
            placedBy: "Placed By",
            total: "Total",
            viewDetails: "View details",
            processing: "Processing order",
            deployment: "Deployment started",
            validating: "Validating deployment",
            completed: "Deployment completed",
            order: "Order",
            orderNumber: "Order #{{orderCode}}",
            orderTotal: "Order Total",
            status: "Status",
            link: "Order History",
            legacy: "Legacy order",
            orderDate: "Order Date",
            orderBy: "Order By",
            endUser: "End User",
            loTypes: "LO Types",
            view: "View",
            download: "Download",
            title: 'Order history',
            aboutExpired: "Card expires soon",
            expired: "Card is expired",
            paymentFailed: "Payment failed",
            paymentChange: "Change payment method",
            update: "Update",
            success: "Success",
            failure: "Failure",
            updatePaymentSuccess: "Payment method has been successfully updated.",
            updatePaymentFail: "Failed to update payment method."

        },
        payments: {
            errors: {
                PaymentConfigurationError: 'We are sorry, but your transaction could not be completed at this time. Please contact a <span id="contactUs">SLB representative</span>so that they can assist you in completing your order.',
                ChaseProfileUpdateError: 'We are sorry but your transaction could not be completed at this time; please try again later or contact customer service at 555-555-5555',
                SessionTransferUrlInitializationError: 'We are experiencing a technical issue, please try again later.',
                NoSuchInvoiceReferenceError: "Invoice reference not found",
                SlbExistingInvoiceError: "Existing Invoice {{invoiceNumber}} with status PAID",
                CommerceAdHocModificationError: "Transaction error",
                processPayment: 'We were unable to process your transaction. <br><br> Please <a href="/my-account/online-payments/payment/add">select another payment method</a> <br><br> Or <a id="contactUs">contact a SLB representative</a> so they can assist you in completing your payment'
            }
        }
    }
}
